export default "__VITE_ASSET__CNpHZlCg__"